import React, {useCallback, useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import DangerousHTML from 'coreComponents/DangerousHtml/DangerousHTML';

import {PRODUCT_DESCRIPTION_MAX_LENGTH as maxLength} from 'brandConstants';

import {IProductDescriptionProps} from './IProductDescription';
import messages from './messages';

import styles from './ProductDescription.module.scss';

const ProductDescription = ({text, hideReadMore}: IProductDescriptionProps) => {
	const [readMoreButton, setReadMoreButton] = useState(!hideReadMore && text?.length > maxLength);
	const intl = useIntl();

	const descriptionText = useMemo(() => {
		if (!hideReadMore && text?.length > maxLength && readMoreButton) {
			let breakLetter = maxLength;
			const punctuation = [' ', '.', ',', '!', '?'];

			while (breakLetter > 0) {
				if (!punctuation.includes(text[breakLetter]) || punctuation.includes(text[breakLetter - 1])) {
					break;
				}

				breakLetter--;
			}

			return (text.slice(0, breakLetter));
		} else {
			return (text);
		}
	}, [text, readMoreButton]);

	const dismissReadMore = useCallback(() => {
		setReadMoreButton(false);
	}, []);

	return (
		<div className={cn('product-description', styles['product-description'])}>
			<DangerousHTML
				key={descriptionText}
				html={descriptionText}
				as = "span"
				classNames="text"
			/>
			{readMoreButton && (
				<button
					className={styles['product-description__read-more']}
					onClick={dismissReadMore}
					type="button"
				>
					{intl.formatMessage(messages.readMore)}
				</button>
			)}
		</div>
	);
};

export default ProductDescription;
